import React, { ChangeEventHandler } from 'react'
import styled from 'styled-components'
import StyledText from '../../components/StyledComponents/StyledText';
import { useTheme } from '../../middleware/ThemeContext';
import { CheckCircle } from '@mui/icons-material';

interface CriteriaCheckbox {
    name: string;
    value: string;
    label: string;
    match: string;
    Case: string;
    isCheck?: boolean;
    onClick: (field_key: string, value: string) => void;
    onChange: ChangeEventHandler<HTMLInputElement>;
}

const Bullet = () => {
    const {theme} = useTheme();
    return (
        <span style={{
            display: 'block',
            width: '8px',
            height: '8px',
            backgroundColor: theme.CreateFormTheme.colors.inputBorders,
            borderRadius: '50%',
        }}></span>
    )
}

const CriteriaCheckbox: React.FC<CriteriaCheckbox> = ({ name, value, label, match, isCheck, Case, onClick, onChange }) => {
    const {theme} = useTheme();
  return (
    <Container theme={theme} className={isCheck ? 'checked' : ''}>
        <div style={{ width: '100px' }}>
            <StyledText 
            fontSize='12px' 
            fontWeight={600} 
            textColor={theme.CorporateTheme.colors.headerColor}
            style={{ marginBottom: '5px' }}
            >
                Criteria
            </StyledText>
            <StyledText fontSize='14px' fontWeight={600}>{label}</StyledText>
        </div>
        <div className='d-flex gap-2 align-items-center'>
            <Bullet />
            <StyledText fontWeight={500} textColor={theme.CorporateTheme.colors.textSecondary}>{match}</StyledText>
        </div>
        <div className='d-flex gap-2 align-items-center'>
            <Bullet />
            <StyledText fontWeight={500} textColor={theme.CorporateTheme.colors.textSecondary}>{Case}</StyledText>
        </div>
        <span>
            <CheckCircle fontSize='small' htmlColor={isCheck ? theme.CorporateTheme.colors.primary : theme.CorporateTheme.colors.border} />
            <input 
                type='checkbox' 
                name={name}
                value={value}
                checked={isCheck}
                onChange={onChange}
                style={{ display: 'none' }}
            />
        </span>
    </Container>
  )
}

const Container = styled.label`
    background-color: ${({theme}) => theme.colors.contentBackground};
    cursor: pointer;
    padding: 15px 20px;
    margin-bottom: 10px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.checked {
        background-color: ${({theme}) => theme.CorporateTheme.colors.primaryLightBG};
        border: 1px solid ${({theme}) => theme.CorporateTheme.colors.blueberry};
    }
`;
// const Label = styled.label`
//     display: flex;
//     align-items: center;
//     cursor: pointer;
//     position: relative;
// `;

export default CriteriaCheckbox